import React, { Component, Fragment, Suspense } from "react";
import { connect } from "react-redux";

import TempWorkFlow from "./TempWorkFlow";

// import actions
import { DocumentTemplateActions } from "../../actions";

// import services
import {
  addTemplateComponentService,
  updateTemplateOrder,
  deleteTemplateComponentService,
  updateTemplateComponentService,
  updateTemplateSectionLabelService,
} from "../../actions/DocumentTemplateActions/templateService";

// Components Imports
import { LazyLoad } from "../../commonComponents";
import LZLoader from "../../commonComponents/LZLoader";

const DocumentLazy = LazyLoad(() =>
  import(/* webpackChunkName: "document" */ "../Document"),
);

const { reOrderTemplateSectionList } = DocumentTemplateActions;

class DocumentTemplate extends Component {
  state = {
    mode: "TEMPLATE",
  };

  componentDidMount = () => {
    document.title = "Templates";
  };

  render() {
    const { mode } = this.state;
    const { reOrderSectionListAction, showWorkFlowScreen } = this.props;
    return (
      <Fragment>
        <Suspense fallback={<LZLoader label="please wait..." largelabel />}>
          <DocumentLazy
            {...this.props}
            mode={mode}
            addNewSectionService={addTemplateComponentService}
            deleteSectionService={deleteTemplateComponentService}
            updateSectionService={updateTemplateComponentService}
            updateSectionLabelService={updateTemplateSectionLabelService}
            reOrderSectionListAction={reOrderSectionListAction}
            reOrderSectionListService={updateTemplateOrder}
            toggleAddWorkflowScreen={this._toggleAddWorkflowScreen}
          />
        </Suspense>
        {showWorkFlowScreen && (
          <div className="document-clause-options-pane">
            <TempWorkFlow />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    workflow: { showWorkFlowScreen },
  } = state.TemplateStore;

  return { showWorkFlowScreen };
};

const mapDispatchToProps = {
  reOrderSectionListAction: reOrderTemplateSectionList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTemplate);
